import React, { useRef } from 'react';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

const PhoneNumberInput = ({ value, onChange, onKeyDown, disabled, className }) => {
    const inputRef = useRef(null);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (inputRef.current) {
                inputRef.current.blur(); // Remove focus from the input field
            }
            onChange({ target: { name: 'phone', value: event.target.value } });
        }
    };

    const clearInput = () => {
        onChange({ target: { name: 'phone', value: '' } });
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    return (
        <div className={`custom-phone-input input-wrapper ${className || ''}`}>
            <PhoneInput
                defaultCountry="us"
                value={value}
                onChange={(phone) => onChange({ target: { name: 'phone', value: phone } })}
                placeholder="Enter phone number"
                inputProps={{
                    ref: inputRef,
                    onKeyDown: handleKeyDown || onKeyDown,  // Use the passed onKeyDown event
                    disabled: disabled,  // Pass the disabled prop
                    className: 'clearable-input'  // Apply the same class as other inputs
                }}
            />
            {value && (
                <button
                    className="clear-button"
                    onClick={clearInput}
                    type="button"
                    aria-label="Clear phone input"
                >
                    ×
                </button>
            )}
        </div>
    );
};

export default PhoneNumberInput;
